import axios from "axios";
import { retailStateUrl, documentUrl } from "../../Config/Url";

export const retailStateService = {
  aricleCardSearch,
  searchArticleList,
  documentDetails,
  getDocumentById,
};

async function searchArticleList(
  storeId,
  sortName,
  isAsc,
  searchText,
  pageIndex,
  pageSize
) {
  return axios
    .put(`${retailStateUrl}/retailState`, {
      storeId,
      sortName,
      isAsc,
      searchText,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function aricleCardSearch(
  storeId,
  productGuid,
  searchText,
  pageIndex,
  pageSize
) {
  return axios
    .put(`${retailStateUrl}/articleCard`, {
      storeId,
      productGuid,
      searchText,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid) {
  return axios
    .get(`${documentUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}
